import { useCallback, useRef, useState } from 'react';

/**
 * 溢出检测 tooltip：仅当文本被截断时才显示完整内容。
 * 通过比较 scrollHeight/scrollWidth 与 offsetHeight/offsetWidth 判断是否溢出。
 */
export const useOverflowTip = (text: string) => {
  const [tip, setTip] = useState<string | null>(null);
  const tipRef = useRef<string | null>(null);

  const handleMouseEnter = useCallback(
    (e: React.MouseEvent<HTMLElement>): void => {
      const el = e.currentTarget;
      const isOverflow =
        el.scrollHeight > el.offsetHeight ||
        el.scrollWidth > el.offsetWidth;
      const next = isOverflow ? text : null;
      if (tipRef.current !== next) {
        tipRef.current = next;
        setTip(next);
      }
    },
    [text],
  );

  return { tip, handleMouseEnter };
};
